module.exports = __webpack_public_path__ + "img/conheca_icone_04.2c941983.png";